import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles({
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    textAlign: 'center',
  },
  title: {
    fontSize: 18,
    fontWeight: 600,
    margin: 0,
  },
  subtitle: {
    fontSize: 14,
    color: 'var(--onSurfaceMuted)',
    marginTop: 4,
  },
});
